import { createWritableStore } from './CreateLocalStorageStore';

/**
 * If `true`, the SmartGIS "tablet mode" has been toggled on
 * TODO: This is not a robust solution. When flipping a tablet from vertical to horizontal, the value won't update properly as it is set once when the app is loaded. May cause issues. 
 * Use this store purely for network and resource optimization, not UI logic. 
 */
const tabletModeStore = createWritableStore<boolean>('tabletModeStore', false);
tabletModeStore.useLocalStorage();

export {
    tabletModeStore
};
